<template>
    <Card
        :size="`col-md-10 col-lg-8 col-xl-6 max-xl-670`"
        :modifiers="`py-5`"
    >
        <template slot="card-header">
            <div class="card-header__icon">
                <svg-rndr
                    :width="163"
                    svg="check-circle-green.svg"
                />
            </div>
            <h1
                class="mt-4"
                v-translate
            >Recovery Link Sent</h1>
        </template>
        <template slot="card-body">
            <div class="form-group row justify-content-center">
                <div class="col-md-8">
                    <p
                        class="text-standard"
                        v-translate='{email: email}'
                    >
                        We've sent you an email to %{ email } with a link to finish resetting your password.
                    </p>

                    <p class="text-standard">
                        If you still can't log in, have us <a
                            href="#"
                            class="link"
                            @click="resendEmail"
                        >resend the email</a> or contact SmartCharts support service.
                    </p>
                </div>
            </div>
            <div class="form-group row justify-content-center mb-0">
                <div class="col-md-6 text-center">
                    <router-link
                        to="/"
                        class="btn btn-primary btn--2x"
                        v-translate
                    >Return To Login</router-link>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-md-8">
                    <flash-message></flash-message>
                </div>
            </div>
        </template>
    </Card>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import FlashMessage from '@C/FlashMessage';
import Card from '@C/Card.vue';
import errorsMixin from '@M/errors';
export default {
    name: 'ResetEmailSent',
    data: function () {
        return {
            email: this.$route.params.email
        };
    },
    methods: {
        ...mapActions({
            resendEmail: 'Auth/resendEmail'
        })
    },
    components: {
        Card,
        FlashMessage
    },
    mixins: [errorsMixin]
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/stages/ResetEmailSent.vue